<template>
  <div class="index-main">
    <div class="swiper-container">
      <div class="index-swiper swiper-wrapper">
        <div class="swiper-slide  slide-item">

          <div class="swiper mySwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide ">
                <img src="/image/bg/1.jpg" alt="">
              </div>
              <div class="swiper-slide ">
                <img src="/image/bg/2.jpg" alt="">
              </div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>

          <div class="slide-content">
            <div class="title">
              山东昱晟玻璃制品有限公司
              <div class="line"></div>
            </div>
            <div v-if="[0].includes(showIndex)" class="content-main">
              <div class="item animated backInLeft" @click="toUrl('/technology/index')">
                <img src="/image/img/50ml.dcac620.jpg" alt="">
                <div class="desc">生产工艺</div>
              </div>
              <div class="item animated backInUp" @click="toUrl('/about/index')">
                <img src="/image/image/about.jpg" alt="">
                <div class="desc">公司简介</div>
              </div>
              <div class="item animated backInRight" @click="toUrl('/contact/index')">
                <img src="/image/image/lianxiwomen.jpeg" alt="">
                <div class="desc">联系我们</div>
              </div>
            </div>
          </div>

        </div>
        <div class="swiper-slide slide-item">
          <div class="slide-content">
            <div class="title">
              公司简介
              <div class="line"></div>
            </div>
            <div v-if="showIndex == 1" class="content-main2 about-item">
              <img class="bg-img animated backInLeft" src="/image/image/about.jpg" alt="">
              <div class="about-desc animated backInRight">
                <div class="a-d-item">
                  <div class="a-d-title">公司简介</div>
                  <div class="a-d-contect">山东昱晟玻璃制品有限公司是一家国内玻璃瓶生产企业；口服液瓶、药用玻璃瓶、抗生素瓶、安瓿瓶、管制西林瓶、管制螺口滴管瓶、硼硅奶瓶、方瓶，滚珠瓶，香水瓶，化妆品瓶、甲油瓶等等。 盖子系列；口服液铝盖、医用铝塑盖 、黑白塑料盖、医用级硅胶垫片、电化铝盖、胶头、滴管、内塞、等 。 我们可以为您提供磨砂、丝印、烫金、烫银、电镀、喷涂等工艺后加工。我们将以最优质的产品和完善的服务，热烈欢迎各界朋友光临指导和业务洽谈；“以人为本，靠技术进步”是公司发展的战略方针。已更新的设计理念不断创新，引进电脑化管理系统，向现代化企业迈进，是自己的产品日趋完善；卓越的品质，完美的追求，是公司的一贯质量宗旨；质量是企业的生命，公司始终坚持“以质量取胜，信誉为本”的原则。 公司已近两百种产品畅销全国并出口各个国家和地区，深得了国内外诸多知名企业的信赖；结成与国内外商家双赢合作，共同发展，共创辉煌。</div>
                </div>
                <!-- <div class="a-d-line"></div>
                <div class="a-d-item">
                  <div class="a-d-title">公司主营</div>
                  <div class="a-d-contect">陶瓷纤维系列产品：包括棉、毯、模块、板、纸、毡、异形件。可溶性纤维系列产品：包括棉、毯、模块、板、纸、毡、异形件。纳米微孔板、纤维表面涂料、纤维灌浆料等其它特殊材料。广泛应用于石油、化工、电力、冶金、消防、建材、机械、造船、航天等行业。并根据客户需要配套其它关联厂家的产品，对客户提供一站式服务。</div>
                </div> -->
              </div>
            </div>
             <!--<div v-if="showIndex == 1" class="content-main2 ">
              <div class="item animated backInLeft" @click="toUrl('/product/taocixianwei')">
                <img src="/image/image/b0710b177466bcdad46825cb788d0f9c.jpeg" alt="">
                <div class="desc">航空航天</div>
              </div>
              <div class="item animated backInUp" @click="toUrl('/product/taocixianwei')">
                <img src="/image/image/73308d0b19fd41ab7a68ebeec2522353.jpeg" alt="">
                <div class="desc">工程建筑</div>
              </div>
              <div class="item animated backInRight" @click="toUrl('/product/taocixianwei')">
                <img src="/image/image/a21aa329c56799627422b4c35b678889.jpeg" alt="">
                <div class="desc">陶瓷玻璃</div>
              </div>
              <div class="item animated backInRight" @click="toUrl('/product/taocixianwei')">
                <img src="/image/image/2a167718b688c90289975ffcf0458f0e.jpeg" alt="">
                <div class="desc">家用电器</div>
              </div>
              <div class="item animated backInRight" @click="toUrl('/product/taocixianwei')">
                <img src="/image/image/nW6aqTFYSiuBm8kFqOXHsQ.jpg" alt="">
                <div class="desc">石油石化</div>
              </div>
              <div class="item animated backInRight" @click="toUrl('/product/taocixianwei')">
                <img src="/image/image/c4af5b16ac650f484b235810a6b2b279.jpeg" alt="">
                <div class="desc">冶金锻造</div>
              </div> 
            </div>-->
          </div>
        </div>
        <div class="swiper-slide slide-item">
          <div class="slide-content">
            <div class="title">
              联系我们
              <div class="line"></div>
            </div>

            <div class="slid-map" v-if="[2].includes(showIndex)">
              <!-- <img class="map-img animated backInLeft" src="/image/image/map.fcc44c4.jpg" alt=""> -->
              <div class="about-us animated backInRight">
                <div class="row"><img src="/image/image/tel.png" alt="">  代经理 15725805558</div>
                <!-- <div class="row"><img src="/image/image/email.png" alt="">Email:zhongshengwool@163.com</div> -->
                <div class="row"><img src="/image/image/addr.png" alt="">地址：山东省淄博市沂源县县城</div>
                <!-- <div class="row">COPYRIGHT © 2019.</div> -->
                <div class="row">©鲁ICP备20028021号-1</div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
    <div class="animate-more">
      <img src="@/assets/image/xiangxiazhanhang.png" alt="">
    </div>
  </div>
</template>
 
<script>
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import Swiper from 'swiper'
export default {
  // beforeRouteLeave(to, form, next) {
  //   window.removeEventListener('scroll', this.handleScroll, true)
  //   next()
  // },
  data() {
    return {
      showIndex: 0,
    }
  },
  created() {},
  mounted() {
    const that = this
    new Swiper('.swiper-container', {
      // pagination: '.swiper-pagination',
      direction: 'vertical',
      slidesPerView: 1,
      paginationClickable: true,
      spaceBetween: 3,
      // loop: true,
      mousewheelControl: true,
      nextButton: '.animate-more',
      onSlideChangeEnd: function (swiper) {
        that.showIndex = swiper.activeIndex
      },
    })

    new Swiper('.mySwiper', {
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      spaceBetween: 30,
      loop: true,
      autoplay: 3500,
      autoplayDisableOnInteraction: false,
    })
  },
  methods: {
    toUrl(path) {
      this.$router.push(path)
    },
  },
}
</script>
 
<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
}
.index-swiper {
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
  }
}
.mySwiper {
  position: relative;
  width: 100%;
  height: 40%;
  .swiper-wrapper {
    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }
  }
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url('/image/xiangzuo.png');
  background-size: 100% 100%;
  width: 44px;
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url('/image/xiangyou.png');
  background-size: 100% 100%;
  width: 44px;
}
</style>